module.exports = __webpack_public_path__ + "img/Dashboard.86256d50.svg";